/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IUserState {
  forgotPassModal: string;
  previousForgotPassModal: string;
  isShowPassModal: boolean;
  userResetOption: string;
  resetOtp: string;
}

const initialState: IUserState = {
  forgotPassModal: '',
  previousForgotPassModal: '',
  isShowPassModal: false,
  userResetOption: '',
  resetOtp: ''
};

export const forgotPassSlice = createSlice({
  name: 'forgotPass',
  initialState,
  reducers: {
    setForgotPassModal: (state: IUserState, action: PayloadAction<string>) => {
      const { payload } = action;
      state.forgotPassModal = payload;
    },
    setPreviousForgotPassModal: (state: IUserState, action: PayloadAction<string>) => {
      const { payload } = action;
      state.previousForgotPassModal = payload;
    },
    setIsShowPassModal: (state: IUserState, action: PayloadAction<boolean>) => {
      const { payload } = action;
      state.isShowPassModal = payload;
    },
    setUserResetOption: (state: IUserState, action: PayloadAction<string>) => {
      const { payload } = action;
      state.userResetOption = payload;
    },
    setResetOtp: (state: IUserState, action: PayloadAction<string>) => {
      const { payload } = action;
      state.resetOtp = payload;
    }
  }
});

const { actions, reducer } = forgotPassSlice;
export const {
  setForgotPassModal,
  setPreviousForgotPassModal,
  setIsShowPassModal,
  setUserResetOption,
  setResetOtp
} = actions;
export default reducer;
